export default "__VITE_ASSET__CdChH8Dg__"